const serviceData = [
  {
    icon: "ri-truck-line",
    title: "Free Shipping",
    subtitle: "Wherever you are we deliver.",
    bg: "#fdefe6",
  },
  {
    icon: "ri-refresh-line",
    title: "Easy Returns",
    subtitle: "Money back guarantee .",
    bg: "#ceebe9",
  },
  {
    icon: "ri-secure-payment-line",
    title: "Secure Payment",
    subtitle: "We accept all kinds of payments.",
    bg: "#e2f2b2",
  },
  {
    icon: "ri-exchange-dollar-line",
    title: " Availability Guarantee",
    subtitle: "Pride ourselves .",
    bg: "#d6e5fb",
  },
];

export default serviceData;
